export default __webpack_public_path__ + "static/media/roadmap-bg-bottom-min.0ae21382.png";